import { PropertyQueryResponse } from './_models';
import { httpClient } from 'app/api/http/http-client';

const getProperties = (): Promise<PropertyQueryResponse> => {
  return httpClient.get('/Property/byUser');
};

export { getProperties };
